import React from 'react';
import { useTranslation } from 'react-i18next';
import { imageAbsolutePath } from '../../utils/utils';
import styles from './VipCard.module.css';
import { VipCardTypes } from './VipCard.types';

const logo = imageAbsolutePath('logo.png');

const VipCard: React.FC<VipCardTypes> = ({ withLink = true }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.vipCard}>
      <img className={styles.cardLogo} src={logo} alt="logo" />
      <p className={styles.cardTitle}>{t('homePage.vipCard.vipCard')}</p>
      <div className={styles.ruleList}>
        <div className={styles.ruleListItem}>
          <i className="icon-car" />
        </div>
        <div className={styles.ruleListItem}>
          <i className="icon-motorcycle" />
        </div>
        <div className={styles.ruleListItem}>
          <i className="icon-tractor" />
        </div>
        <div className={styles.ruleListItem}>
          <i className="icon-e-bike" />
        </div>
      </div>
      {withLink && (
        <a className="linkBtn" rel="noopener noreferrer" target="_blank" href={t('homePage.btn.redeemLink')}>
          {t('homePage.btn.redeemCode')}
          <i className="icon-arrow" />
        </a>
      )}
    </div>
  );
};

export default VipCard;
